import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation removeProcessingUserRole($username: String!, $role: String!) {
      deleteProcessingUserRole(
        objectData: { username: $username, role: $role }
      ) {
        success
      }
    }
  `,
  mutationName: "removeProcessingUserRole",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/role/removeUserRole.js